// src/components/store/sections/blog-posts/BlogV68OrigamiribbonOceanCyan.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV68OrigamiribbonOceanCyan(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={68}
      archKey="origami_ribbon"
      archLabel="Origami Ribbon Articles"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
